import React, { Component } from "react";
import { Tabs, Tab, Row, Col, Container } from "react-bootstrap";
import { withRouter } from "react-router-dom";
import List from "./List";
import LiveOrder from "./LiveOrder";
import BrandedLoading from "../common/BrandedLoading";
import { styles } from "./styles";


class OrderTabs extends Component {
  constructor(props) {
    super(props);
    const roleName = this.getRoleName();
    this.state = {
      roleName,
      activeTab: this.getTabFromUrl(),
      currentPage: this.getCurrentPage(),
      dataFetched: {
        LiveOrders: true,
        History: true,
      },
    };
  }
  getRoleName = () => {
    try {
      const u = JSON.parse(localStorage.getItem("user"));
      return u?.roleDetails?.name || "";
    } catch {
      return "";
    }
  };
  getPermissions = () => {
    if (this.props.permissions && Object.keys(this.props.permissions).length) return this.props.permissions;
    if (this.props.auth?.user?.roleDetails?.permissions) return this.props.auth.user.roleDetails.permissions;
    try {
      const u = JSON.parse(localStorage.getItem("user"));
      return u?.roleDetails?.permissions || {};
    } catch {
      return {};
    }
  }
  hasLive = () => {
    const perms = this.getPermissions();
    return !!perms?.store?.subModules?.orders?.subModules?.liveOrders?.isEnabled;
  };

  hasHistory = () => {
    const perms = this.getPermissions();
    return (
      !!perms?.store?.subModules?.orders?.subModules?.orderHistory?.isEnabled ||
      !!perms?.store?.subModules?.orders?.isEnabled
    );
  };

  getTabFromUrl = () => {
    const { location } = this.props;
    const roleName = this.getRoleName();
    const liveAllowed = roleName === "Super Admin" || this.hasLive();
    const historyAllowed = roleName === "Super Admin" || this.hasHistory();
    if (location.pathname.includes("/liveorders") && liveAllowed) {
      return "LiveOrders";
    }
    if (historyAllowed) return "History";
    return liveAllowed ? "LiveOrders" : "History";
  };

  getCurrentPage = () => {
    const { match, location } = this.props;
    if (location.pathname.includes('/liveorders')) return 1;
    const p = parseInt(match?.params?.page || "1", 10);
    return Number.isNaN(p) ? 1 : p;
  };

  componentDidMount() {
    const { location, history } = this.props;
    if (location.pathname === '/orders') {
      history.replace('/orders/1');
    }

    document.body.style.margin = '0';
    document.body.style.padding = '0';
    document.body.style.height = '100%';
    document.body.style.overflow = 'auto';  
    document.documentElement.style.height = '100%';
    document.documentElement.style.overflow = 'auto'; 
  }

  componentWillUnmount() {
    document.body.style.margin = '';
    document.body.style.padding = '';
    document.body.style.height = '';
    document.body.style.overflow = '';
    document.documentElement.style.height = '';
    document.documentElement.style.overflow = '';
  }

  componentDidUpdate(prevProps) {
    const { location } = this.props;
    if (prevProps.location.pathname !== location.pathname) {
      const newTab = this.getTabFromUrl();
      const newPage = this.getCurrentPage();

      if (newTab !== this.state.activeTab) {
        this.setState({
          activeTab: newTab,
          currentPage: newPage,
        });
      }
    }
  }

  handleSelect = (key) => {
    const { history } = this.props;
    const { roleName, currentPage } = this.state;
    const isSuperAdmin = roleName === "Super Admin";

    if (key === "LiveOrders") {
      if (!this.hasLive() && !isSuperAdmin) return;
      history.push("/liveorders/1");
    }

    if (key === "History") {
      if (!this.hasHistory() && !isSuperAdmin) return;
      history.push(`/orders/${currentPage}`);
    }

    this.setState({ activeTab: key });
  };

  handlePageChange = (pageNumber) => {
    const { history } = this.props;
    const { roleName } = this.state;
    const isSuperAdmin = roleName === "Super Admin";
    if (this.hasHistory() || isSuperAdmin) {
      history.push(`/orders/${pageNumber}`);
      this.setState({ currentPage: pageNumber });
    } else if (this.hasLive() || isSuperAdmin) {
      history.push("/liveorders/1");
      this.setState({ activeTab: "LiveOrders", currentPage: 1 });
    }
  };

  render() {
    const { activeTab, dataFetched, currentPage, roleName } = this.state;
    const { location } = this.props;

    const isSuperAdmin = roleName === "Super Admin";
    const showLive = isSuperAdmin || this.hasLive();
    const showHistory = isSuperAdmin || this.hasHistory();

    if (
      location.pathname.includes("/detail") ||
      location.pathname.includes("/print")
    ) {
      return null;
    }

    return (
      <div style={styles.mainContainer}>
        <div style={styles.tabHeader}>
          <Container fluid>
            <Row>
              <Col>
                <div style={styles.tabsContainer}>
                  <Tabs
                    activeKey={activeTab}
                    onSelect={this.handleSelect}
                    className="flex-grow-1"
                    transition={false}
                    style={styles.tabStyle}
                  >
                    {showLive && <Tab eventKey="LiveOrders" title="Live Orders" />}
                    {showHistory && <Tab eventKey="History" title="History" />}
                  </Tabs>
                </div>
              </Col>
            </Row>
          </Container>
        </div>

        {/* Scrollable Content */}
        <div style={styles.contentArea}>
          <Container fluid>
            {activeTab === "LiveOrders" &&
              (dataFetched.LiveOrders ? (
                <LiveOrder {...this.props} />
              ) : (
                <BrandedLoading />
              ))}
            {activeTab === "History" &&
              (dataFetched.History ? (
                <List 
                  {...this.props} 
                  currentPage={currentPage}
                  onPageChange={this.handlePageChange}
                />
              ) : (
                <BrandedLoading />
              ))}
          </Container>
        </div>
      </div>
    );
  }
}

export default withRouter(OrderTabs);
